import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { GetVindiGatewayToken } from '@frontend/unhideschool/modules/membership/actions/membership-subscription.actions';
import creditCardType, { types as CardType } from 'credit-card-type';

interface CardTypeData {
  niceType: string;
  type: string;
  gaps: number[];
  lengths: number[];
  code: { name: string, size: number };
}

@Component({
  selector: 'unh-remove-member-confirm',
  styleUrls: ['./payment-retry.dialog.scss'],
  templateUrl: './payment-retry.dialog.html'
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class RetryPaymentDialog implements OnInit, OnDestroy {
  @Input() paymentProfile: any;
  @Input() subscriptionId: any;
  @Input() editProfile: any;
  @Input() tryAgain: any;

  isLoading = false;
  errorPayment = false;
  partialData: any = [];

  card_number_first_four: number;
  isTyping = false;

  cNumber_1: number;
  cNumber_2: number;
  cNumber_3: number;
  cNumber_4: number;

  constructor(
    public dialogRef: MatDialogRef<RetryPaymentDialog>,
    private store: Store,
    private r2: Renderer2,
  ) { }

  ngOnInit(): void {
    const htmlEl = document.querySelector('html');
    this.r2.setStyle(htmlEl, 'overflow-y', 'hidden');

    this.card_number_first_four = this.paymentProfile.card_number_first_six.toString().slice(0, 4);
  }

  ngOnDestroy() {
    const htmlEl = document.querySelector('html');
    this.r2.setStyle(htmlEl, 'overflow-y', 'unset');
  }

  paymentRetryNewData(formdata) {
    this.errorPayment = false;
    this.isLoading = true;

    this.store.dispatch(
      new GetVindiGatewayToken(
        formdata,
        this.subscriptionId,
        this.editProfile
      )
    ).subscribe({
      complete: () => {
        this.dialogRef.close(this.editProfile);
      },
      error:
        (err) => {
          this.errorPayment = true;
          this.isLoading = false;
        }
    });
  }

  get cardTypeData(): CardTypeData {
    const firstsix = this.paymentProfile && this.paymentProfile.card_number_first_six;
    const cardType = firstsix && creditCardType(firstsix)[0];
    return cardType;
  }

  fillCard(data) {
    if (data.holder_name || data.card_number || data.card_cvv || data.exp_month || data.exp_year) {
      this.isTyping = true;
    } else {
      this.isTyping = false;
    }

    this.cNumber_1 = data.card_number?.toString().slice(0, 4);
    this.cNumber_2 = data.card_number?.toString().slice(4, 8);
    this.cNumber_3 = data.card_number?.toString().slice(8, 12);
    this.cNumber_4 = data.card_number?.toString().slice(12, 16);

    this.partialData = data;
  }
}

